module.exports = __webpack_public_path__ + "img/call-to-action.77ccb87e.png";